import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { ProtocoloArquivo, StatusProtocolo, STATUS_PROTOCOLO, TIPO_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { OcorrenciaValidacaoVO } from '../ocorrencia-validacao.vo';

@Component({
    selector: 'app-protocolo-listagem',
    templateUrl: './protocolo-listagem.component.html',
    styleUrls: ['./protocolo-listagem.component.scss'],
    standalone: false
})
export class ProtocoloListagemComponent implements OnInit, OnChanges {

    @ViewChild('confirmacaoMensagem') desativacaoMsg: TemplateRef<any>;
    @ViewChild('desativacaoBotoes') desativacaoBotoes: TemplateRef<any>;

    @Input() public cnpjAgente: string;
    @Input() public protocolos: ProtocoloArquivo[];
    @Input() public incluirCampoJanelaEnvio = false;
    @Input() public exibirComboTipoArquivo:boolean = false;
    @Input() public atributosPaginacao: EntityPagedRequestParameters;
    @Input() public formatoArquivo: string;
    @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
    @Output() public aposExcluirProtocolo = new EventEmitter();

    public opcoesPaginacao: number[];
    public atributosOrdenacao: EntityOrderedRequestParameters;

    public protocolosPaginados: ProtocoloArquivo[];
    private protocolosTemp: ProtocoloArquivo[];
    private tiposProtocolo = TIPO_PROTOCOLO;

    usuarioTemPermissaoParaExcluirArquivo = false;
    protocoloParaExclusao: ProtocoloArquivo;

    listagemExibida: ProtocoloArquivo[] = [];

    // para o caso de tentativas de exclusao de protocolos
    private ocorrencias: OcorrenciaValidacaoVO[] = [];

    constructor(
        private fileUtils: FileUtilsService, 
        private protocoloService: ProtocoloArquivoService,
        private permissaoService: PermissaoService,
        private loadingService: BnLoadingService,
        private messageService: MessageChannelService,
        private modalService: BnModalMessageService) { }

    ngOnInit(): void {

        //console.log(this.router.getCurrentNavigation().extractedUrl);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.usuarioTemPermissaoParaExcluirArquivo = resp && resp[ROLE_GESTOR_ENVIO];
        });
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosOrdenacao = {
            atributo: '',
            sentido: 'asc'
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.pesquisar(this.atributosPaginacao);
    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
      }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
        this.pesquisar(this.atributosPaginacao);
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.protocolos.sort((a, b) => {
            if (ord.sentido === 'asc') {
                return this.compara(a, b, ord.atributo);
            } else {
                return -1 * this.compara(a, b, ord.atributo);
            }
        });
    }
    obterTipoProtocolo(codigo:string):string{
        return this.tiposProtocolo.filter(p=> p.codigo.includes(codigo))[0].descricao;
    }

    private compara(a, b, atributo): number {
        if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
            return 0;
        } else {
            if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
                return 1;
            } else {
                return -1;
            }
        }
    }

    private fetchFromObject(obj, prop) {
        if (typeof obj === 'undefined') {
            return false;
        }

        const _index = prop.indexOf('.');
        if (_index > -1) {
            return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
        }

        return obj[prop];
    }

    private pesquisar(pesq: EntityPagedRequestParameters) {
        this.protocolosTemp = this.protocolos;
        if (this.protocolosTemp) {
            this.protocolosPaginados = this.protocolosTemp.slice(0, pesq.pageSize);
        }
     }

    downloadArquivoEnvio(idProtocoloArquivo: string) {
      if (this.formatoArquivo == 'csv') {
        this.protocoloService.getArquivoEnvioCsv(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.csv',
                conteudoArquivo, FileUtilsService.TEXT_CSV);
        });
      }
      else {
        this.protocoloService.getArquivoEnvio(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.json',
                JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
        });
      }

    } 

    downloadArquivoResposta(idProtocoloArquivo: string) {
      if (this.formatoArquivo == 'csv') {
        this.protocoloService.getArquivoRespostaCsv(idProtocoloArquivo).subscribe((conteudoArquivo) => {
          this.fileUtils.exportarArquivoUTF8('Arquivo_resposta_' + idProtocoloArquivo + '.CSV',
              conteudoArquivo, FileUtilsService.TEXT_CSV);
        });
      }
      else {
        this.protocoloService.getArquivoResposta(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_resposta_' + idProtocoloArquivo + '.json',
              JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
          });
      }
    } 

    obterLabelStatusProtocolo(statusProtocolo: string) {
        return STATUS_PROTOCOLO.find(status => status.codigo === statusProtocolo).label;
    }

    arquivoPodeSerExcluido(protocolo: ProtocoloArquivo) {        
        const ehUltimoProtocoloDoTipoEnviadoPeloAgenteModalidadePorStatus = protocolo.ordemDecrescenteEnvioPorTipoAgenteModalidadeStatus == 1;
        return protocolo.tipoProtocolo === "4" // recuperacao de credito
            && protocolo.statusProtocolo === StatusProtocolo.SUCESSO
            && this.usuarioTemPermissaoParaExcluirArquivo 
            && ehUltimoProtocoloDoTipoEnviadoPeloAgenteModalidadePorStatus;
    }

    excluirProtocolo(protocolo: ProtocoloArquivo) {

        // TODO: exibir modal pedindo confirmacao antes

        const titulo = 'Confirmação';
        const mensagem = 'Deseja confirmar a exclusão do protocolo? Ao confirmar, a ação não poderá ser desfeita.';

        return this.modalService.abrirConfirm(titulo, mensagem).result
        
        .then(
            (retorno: {value: string}) => {
                if (retorno.value === 'ok') {

                    this.protocoloService.excluirProtocolo(protocolo.idProtocoloNegocio).subscribe(
                        (retorno) => {
                            this.aposExcluirProtocolo.emit();
                            this.loadingService.liberaTela();
                            const msgRetornoProtocolo = (<MensagemRetornoAssincrono> retorno);
            
                            this.messageService.addMessage({
                            title: 'Sucesso',
                            type: 'CRUD_OPERATION',
                            level: messageLevel.SUCCESS,
                            message: msgRetornoProtocolo.mensagem
                            });
                        });
                }
            });           
      }
}
